import { ActionOption } from './ExceptionActionDropdown';

/**
 * Builds a human-readable error message listing the conflicting actions.
 * Accepts the translate function so it can be called from any component context.
 */
export const getActionsErrorMessage = (
  actionValues: string[],
  options: ActionOption[],
  translate: (key: string, params?: Record<string, string>) => string
): string => {
  const labels = actionValues.map(
    (v) => options.find((o) => o.value === v)?.label ?? v
  );
  const actionsText = labels.length === 2
    ? `${labels[0]} and ${labels[1]}`
    : labels.length > 2
      ? `${labels.slice(0, -1).join(', ')} and ${labels[labels.length - 1]}`
      : labels.join(', ');
  return translate('service_exceptions.wrongCombinationActions', {
    actions: actionsText
  });
};
